export const AVATAR_SOURCES = {
  CONTACT_DEFAULT: 'CONTACT_DEFAULT',
  COMPANY_DEFAULT: 'COMPANY_DEFAULT',
  PRODUCT_DEFAULT: 'PRODUCT_DEFAULT',
  CONTACT_OVERRIDE: 'CONTACT_OVERRIDE',
  COMPANY_OVERRIDE: 'COMPANY_OVERRIDE',
  PRODUCT_OVERRIDE: 'PRODUCT_OVERRIDE',
  CONTACT_ENRICHMENT: 'CONTACT_ENRICHMENT',
  COMPANY_ENRICHMENT: 'COMPANY_ENRICHMENT',
  HUBSETTINGS_HUBSPOT_USER: 'HUBSETTINGS_HUBSPOT_USER',
  UNKNOWN: 'UNKNOWN'
};